<template>
  <div class="form-group">
    <label>{{ $t('lang.forms.nationality') }}</label>
    <select
      v-model="selectedCountry"
      class="form-control"
    >
      <option
        disabled
        value=""
      >
        {{ $t('lang.forms.select_nationality') }}
      </option>

      <option
        v-for="nat in nationalityOptions"
        :key="nat.iso2"
        :value="nat.iso2"
      >
        {{ formatLabel(nat) }}
      </option>
    </select>
  </div>
</template>

<script>

import nationalities from '@/data/nationalityOptions.json';
import getCountryFromIp from '@/components/CommonScripts/IPInfo';

export default {
  name: 'UserCountry',
  props: {
    country: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      selectedCountry: '',
    };
  },

  computed: {
    nationalityOptions() {
      const { lang } = this.$store.state.main;

      // alphabetical order
      return [...nationalities].sort((a, b) => {
        const nameA = (a.translations && a.translations[lang]) || a.name;
        const nameB = (b.translations && b.translations[lang]) || b.name;

        return nameA.localeCompare(nameB);
      });
    },
  },

  watch: {
    selectedCountry: {
      immediate: true,
      handler(newVal) {
        if (!newVal) return;
        const selectedCountry = this.nationalityOptions.find(
          (country) => country.iso2 === newVal,
        );
        if (!selectedCountry) {
          this.selectedCountry = '';
          return;
        }
        this.$emit('countrySelected', selectedCountry.iso2);
      },
    },
  },

  async created() {
    this.selectedCountry = this.country || await getCountryFromIp();
  },

  methods: {
    formatLabel(nat) {
      const { lang } = this.$store.state.main;

      const name = nat.translations[lang] || nat.name;

      return `${nat.emoji} ${name}`;
    },
  },
};
</script>
